// src/pages/NotFoundPage.jsx

import React from 'react';

const NotFoundPage = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen text-center px-4">
      <h1 className="text-6xl font-bold text-gray-500">404</h1>
      <p className="text-xl mt-4">Trang bạn tìm không tồn tại.</p>
    </div>
  );
};

export default NotFoundPage;
